export const parseInputMinMaxValue = (value: number, option: number, type: 'min' | 'max') => {
  if (type === 'min' && value > 0 && value < option) return value

  if (type === 'max' && value < option && value > 0) return value

  return option
}
